import React, { useContext, useEffect, useState } from "react";
import styles from "./VacancyCard.module.scss";
import PathContext from "../../context/path";
import { Link } from 'react-router-dom';

const VacancyCard = (props) => {
  const path = useContext(PathContext);
  const { title, city, exp, type, href, updateHrefVacancy, isInternship } = props;
  const [searchParam, setSearchParam] = useState('');
  const paramName = isInternship ? 'internship_id' : 'vacancy_id';
  const pathname = isInternship ? 'internship' : 'vacancy';
  useEffect(()=>{
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    searchParams.append(paramName, href);
    url.search = searchParams.toString();
    setSearchParam(url.search);
  },[href, paramName]);
  return (
    <>
      <Link to={{pathname, search: searchParam}} className={styles.wrap} onClick={()=>{updateHrefVacancy(href)}}>
        <div className={styles.col}>{title}</div>
        <div className={styles.col}>{city}</div>
        <div className={styles.col}>{exp}</div>
        <div className={styles.col}>{type}</div>
      </Link>
    </>
  );

}

export default VacancyCard;
